import { notificationSettings } from "../../constants/actionTypes";

const INITIAL_STATE = {
  notificationTypes: "",
  notificationTypesList: "",
  profileUpdated: "",
  errorData: "",
  reportSettings: "",
  successReportSettings: "",
  reportErrorData: "",
};

const notificationSettingsReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case notificationSettings.SUCCESS_NOTIFICATION_TYPES:
      return {
        ...state,
        notificationTypes: action?.payload?.data,
      };
    case notificationSettings.SUCCESS_NOTIFICATION_TYPES_LIST:
    case notificationSettings.SUCCESS_NOTIFICATION_SETTINGS:
      return {
        ...state,
        notificationTypesList: action?.payload?.data,
      };
    case notificationSettings.SUCCESS_PHONE_NUMBER:
      return {
        ...state,
        profileUpdated: action?.payload?.data,
      };
    case notificationSettings.ERROR_NOTIFICATION_TYPES:
    case notificationSettings.ERROR_NOTIFICATION_TYPES_LIST:
    case notificationSettings.ERROR_NOTIFICATION_SETTINGS:
    case notificationSettings.ERROR_PHONE_NUMBER:
      return {
        ...state,
        errorData: action?.payload,
      };
    case notificationSettings.FETCH_REPORT_NOTIFICATION_TYPE_LIST:
    case notificationSettings.SUCCESS_REPORT_NOTIFICATION_TYPE_LIST:
      return {
        ...state,
        reportSettings: action?.payload,
      };
    case notificationSettings.SUCCESS_UPDATE_REPORT_NOTIFICATION:
      return {
        ...state,
        successReportSettings: action?.payload,
      };
    case notificationSettings.ERROR_REPORT_NOTIFICATION_TYPE_LIST:
      return {
        ...state,
        reportErrorData: action?.payload,
      };
    default:
      return state;
  }
};

export default notificationSettingsReducer;
